import { Box, Paper, Typography } from "@mui/material";
import React from "react";
import useReceipts from "../../../hooks/useReceipts.jsx";
import SelectAnio from "../select/SelectAnio.jsx";
import Table from "./Table.jsx";

const TableDailyReceipts = () => {
  const toISODate = (date) => date.toLocaleDateString("en-CA");
  const startDate = new Date();
  const endDate = new Date(startDate);
  endDate.setDate(startDate.getDate() + 7);

  const filters = {
    situacion: "Aceptado",
    start_date: toISODate(startDate),
    end_date: toISODate(endDate),
  };
  const { data, loading, error } = useReceipts(true, filters);

  const columns = [
    { header: "ARC", accessor: "arc" },
    { header: "NRL", accessor: "local_reference_number" },
    { header: "Fecha Expedición", accessor: "date_of_preparation" },
    { header: "Situación", accessor: "situacion" },
    { header: "Procesado", render: (row) => row["processed"] ? "Completo" : "Incompleto" },
    { header: "N.I.F Destinatario", accessor: "message_recipient" },
  ];

  const renderContent = () => {
    if (loading) return <div>Cargando declaraciones...</div>;
    if (error) return <div className="text-red-600">Error: {error.response.data.message}</div>;
    if (!data || data.length === 0) return <div>No se han encontrado ninguna vuelo pendiente</div>;

    return <Table columns={columns} data={data} />;
  };

  return (
    <Paper variant="outlined" sx={{ p: 3, borderColor: "gray.200" }}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={3}
      >
        <Typography variant="h6" component="h2" fontWeight="bold">
          Vuelos pendientes
        </Typography>
      </Box>
      <Box sx={{ height: "100%", width: "100%" }}>
        {renderContent()}
      </Box>
    </Paper>
  );
};

export default TableDailyReceipts;
